angular
    .module('signalview.quickAnalytics')

    .constant('QUICK_ANALYTICS_DIRECTION', {
        AGGREGATION: 'aggregation',
        TRANSFORMATION: 'transformation',
    });
